import { useUpdateBot } from '../../hooks'
import { showSuccessToast } from '@bpinternal/ui-kit-next'
import { useQueryClient } from '@tanstack/react-query'
import { useQueryKeys } from '../../hooks'

type Props = { botId: string; workspaceId: string; alwaysAlive: boolean; botName?: string }

export function useUpdateAlwaysAlive() {
  const { mutate: updateBot, ...rest } = useUpdateBot()
  const queryClient = useQueryClient()
  const queryKeysUsage = useQueryKeys().getWorkspaceUsage

  const updateAlwaysAlive = ({ botId, alwaysAlive, workspaceId, botName }: Props) => {
    return updateBot({
      id: botId,
      workspaceId,
      alwaysAlive,
      onSuccess: () => {
        showSuccessToast(
          `The always alive mode has been turned ${alwaysAlive ? 'on' : 'off'}${
            botName ? ` for the bot ${botName}` : ''
          }`
        )
        queryClient.invalidateQueries({ queryKey: queryKeysUsage(workspaceId) })
      },
    })
  }

  return { mutate: updateAlwaysAlive, ...rest }
}
